import { Component, Inject, OnInit } from "@angular/core";
import { FormArray, FormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TipoPessoa } from "src/app/modules/admin/types/TipoPessoa";
import { HelperService } from "src/app/utils/helper.service";

@Component({
  selector: 'app-add-empresa',
  templateUrl: './add-empresa.component.html',
  styleUrls: ['./add-empresa.component.css']
})
export class AddEmpresaComponent implements OnInit {

  empresaForm!: FormGroup;
  orgao = false;
  loading = false;
  tipos: TipoPessoa[] = [
    { label: 'Sócio', value: 'socio' },
    { label: 'Representante Legal', value: 'representante_legal' },
    { label: 'Síndico', value: 'sindico' }
  ];

  constructor(
    public dialogRef: MatDialogRef<AddEmpresaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public helper: HelperService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.empresaForm = this.fb.group({
      cnpj: [{ value: this.data?.cnpj ?? null, disabled: true }],
      nome_fantasia: [null],
      razao_social: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      telefone: [null, Validators.required],
      cep: [null, Validators.required],
      id_endereco: [null],
      logradouro: [null, Validators.required],
      numero: [null],
      complemento: [null],
      bairro: [null, Validators.required],
      municipio: [null, Validators.required],
      id_municipio: [null],
      uf: [null, Validators.required],
      representantes: this.fb.array([this.criarRepresentanteFormGroup()]),
    });
  }

  get representantes(): FormArray {
    return this.empresaForm.get('representantes') as FormArray;
  }

  private criarRepresentanteFormGroup(): FormGroup {
    return this.fb.group({
      cpf: [null, Validators.required],
      nome: [null, Validators.required],
      tipo: [null],
      email_representante: [null, [Validators.required, Validators.email]],
      tel_representante: [null, Validators.required],
    });
  }

  adicionarRepresentante(): void {
    this.representantes.push(this.criarRepresentanteFormGroup());
  }

  removerRepresentante(index: number): void {
    if (this.representantes.length > 1) {
      this.representantes.removeAt(index);
    }
  }

  setEndereco(endereco: any): void {
    if (!endereco) {
      return;
    }

    this.empresaForm.patchValue({
      id_endereco: endereco.id,
      cep: endereco.cep,
      logradouro: endereco.logradouro,
      bairro: endereco.bairro,
      municipio: endereco.municipio ? endereco.municipio.nome : null,
      id_municipio: endereco.municipio ? endereco.municipio.id : null,
      uf: endereco.municipio ? endereco.municipio.uf : null,
    });
  }

  private parseTelefone(telefone: string) {
    if (!telefone) {
      return { ddd: '', telefone: '' };
    }
    const numeros = telefone.replace(/\D/g, '');
    return {
      ddd: numeros.substring(0, 2),
      telefone: numeros.substring(2)
    };
  }

  closeDialog(): void {
    const rawValues = this.empresaForm.getRawValue();
    const telefone = this.parseTelefone(rawValues.telefone);

    const representantesFormatados = rawValues.representantes.map((rep: any) => {
      const telRep = this.parseTelefone(rep.tel_representante);
      return {
        nome: rep.nome,
        cpf: rep.cpf,
        tipo: rep.tipo,
        contatos: [
          {
            email: rep.email_representante,
            ddd: telRep.ddd,
            telefone: telRep.telefone,
          }
        ],
      };
    });

    this.dialogRef.close({
      cnpj: this.data?.cnpj,
      nome_fantasia: rawValues.nome_fantasia,
      razao_social: rawValues.razao_social,
      contatos: [
        {
          email: rawValues.email,
          ddd: telefone.ddd,
          telefone: telefone.telefone,
        },
      ],
      enderecos: [
        {
          numero: rawValues.numero,
          complemento: rawValues.complemento,
          endereco: {
            id_endereco: rawValues.id_endereco,
            cep: rawValues.cep,
            logradouro: rawValues.logradouro,
            bairro: rawValues.bairro,
            municipio: {
              id_municipio: rawValues.id_municipio,
              nome: rawValues.municipio,
              uf: rawValues.uf,
            }
          }
        },
      ],
      representantes: representantesFormatados
    });
  }
}
